( function ( _s ) {
	const calculateDelay = _el => {
		let result = 0;
		const classes = _el.el[ 0 ].className.split( ' ' );

		classes.forEach( cssClass => {
			if ( cssClass.startsWith( 'animation-delay-' ) ) {
				result = parseInt( cssClass.replace( 'animation-delay-', '' ) );
			}
		} );

		result = result * 200; //150ms of difference between delay values

		return result;
	};

	_s.fn.fadeInUpAnimationOnIntersection = function () {
		return this.el.forEach( el => {
			const _self = _s( el );

			const observer = new IntersectionObserver( entries => {
				entries.forEach( entry => {
					if ( entry.isIntersecting && ! _self.hasClass( 'shown' ) ) {
						const delay = calculateDelay( _self );

						//unobserve after animation is done
						observer.unobserve( entry.target );

						//add delay to animation
						setTimeout( () => {
							_self.addClass( 'shown' );
						}, delay );
					}
				} );
			} );

			observer.observe( _self.el[ 0 ] );
		} );
	};

	_s( document ).ready( () => {
		_s( '.fade-in-up-animation' ).fadeInUpAnimationOnIntersection();
	} );
} )( window._s );
